import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  // Called when an error happens during rendering
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // Called after the error is caught (for logging, monitoring, etc.)
  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    // Log somewhere (Sentry, LogRocket, your backend, etc.)
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }

    console.error("🔥 ErrorBoundary caught an error:");
    console.error(error);
    console.error(errorInfo);
  }

  // Allow user to reset UI programmatically
  resetErrorBoundary = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });

    if (this.props.onReset) {
      this.props.onReset();
    }
  };

  render() {
    const { hasError, error, errorInfo } = this.state;

    if (hasError) {
      // If a custom fallback component is passed:
      if (this.props.FallbackComponent) {
        const Fallback = this.props.FallbackComponent;
        return (
          <Fallback
            error={error}
            errorInfo={errorInfo}
            resetErrorBoundary={this.resetErrorBoundary}
          />
        );
      }

      // If a fallback render function is passed:
      if (this.props.fallbackRender) {
        return this.props.fallbackRender({
          error,
          errorInfo,
          resetErrorBoundary: this.resetErrorBoundary,
        });
      }

      // Default fallback:
      return (
        <div style={{ padding: "30px", textAlign: "center" }}>
          <h2>Something went wrong.</h2>
          <p>{error?.message}</p>
          <button onClick={this.resetErrorBoundary}>Try again</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
